import React from "react";
import { VstLoader } from "vstui";
import HighlightAction from "../../../actions/highlight-action";
import Dispatcher from "../../../dispatcher";
import MarkerAction from "../../../actions/marker-action";
import MarkerStore from "../../../stores/marker-store";
var Isvg = require("../../../../vendor/react-inlinesvg");
import { isEmojiMarker } from "./emoji-reactions/helpers";

export default class HighlighterColors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: null,
      selected:
        !this.props.fasthighlighting && this.props.fast
          ? null
          : MarkerStore.getCurrentMarker()
    };

    this.deleteHighlightOverride = this.deleteHighlightOverride.bind(this);
    this.deleteHighlight = this.deleteHighlight.bind(this);
    this._markersChange = this._markersChange.bind(this);
  }

  componentDidMount() {
    const markers = MarkerStore.getAll().markers;
    this.setState({ markers });
    Dispatcher.bind(Dispatcher.MARKERS_CHANGE, this._markersChange);
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.MARKERS_CHANGE, this._markersChange);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._markersChange();
  }

  _changeMarker(id, e) {
    const currentMarker = MarkerStore.getCurrentMarker();
    if (currentMarker.globalId === id) {
      Fraction.Reporter.gaEvent(
        "V3/highlights",
        "click",
        "clickSameNewHighlightColor"
      );
    } else {
      Fraction.Reporter.gaEvent(
        "V3/highlights",
        "click",
        "changeNewHighlightColor"
      );
    }

    if (this.props.updateHighlight) {
      this.onSlowClick(id);
    } else {
      MarkerAction.setCurrentMarker(MarkerStore.get(id));
      this.props.onFastClick(true);
    }
  }

  _markersChange() {
    const markers = MarkerStore.getAll().markers;
    let selected;
    if (!this.props.fastHighlighting && this.props.fast) {
      selected = null;
    } else {
      selected = MarkerStore.getCurrentMarker();
    }
    this.setState({ markers, selected });
  }

  _setPublicHighlightFlag(e, marker) {
    Jigsaw.User.setFlag("publicHighlights", true, () => {
      Fraction.Helpers.getUser(
        () => {
          this._updateHighlight(e, marker);
        },
        { refresh: true }
      );
    });
    Fraction.Helpers.removeModal();
  }

  _cancelButton() {
    this.props.resetHighlight();
    Fraction.Helpers.removeModal();
  }

  _firstPublicHiglightModal(e, marker) {
    Fraction.Helpers.showModal(
      {
        title: i18n.t("reader.notebook.shared-highlighter"),
        content: (
          <span>{i18n.t("reader.notebook.shared-highlighter-message")}</span>
        ),
        buttons: [
          {
            label: i18n.t("base.cancel"),
            click: () => {
              this._cancelButton();
            },
            defaultClass: "noButton"
          },
          {
            label: i18n.t("base.okay"),
            click: () => {
              this._setPublicHighlightFlag(e, marker);
            }
          }
        ]
      },
      $(e.currentTarget)
    );
  }

  _isDeletable(marker) {
    return (
      this.props.currentHighlight &&
      this.props.updateHighlight &&
      this.props.currentHighlight.markerId === marker.globalId
    );
  }

  _updateHighlight(e, marker) {
    if (
      marker.shared &&
      (!Fraction.User.flags ||
        !Fraction.User.flags.publicHighlights ||
        !Fraction.User.flags.publicHighlights.enabled)
    ) {
      return this._firstPublicHiglightModal(e, marker);
    } else if (this._isDeletable(marker)) {
      return this.deleteHighlight();
    } else if (this.props.currentHighlight) {
      HighlightAction.updateHighlight(
        this.props.currentHighlight.isbn,
        this.props.currentHighlight.syncId,
        { markerId: marker.globalId, noteText: this.props.currentNoteText }
      );
    } else {
      this._changeMarker(marker.globalId, e);
      this.props.addHighlight(this.props.currentNoteText);
    }
    this.props.resetHighlight();
    this.props.closePopover();
  }

  _markerIconClass(marker) {
    let markerIcon = "noButton select-marker";
    if (marker.shared) {
      markerIcon += " select-shared-marker";
    }
    return markerIcon;
  }

  deleteHighlightOverride(currentHighlight) {
    Fraction.Reporter.gaEvent(
      "V3/highlights",
      "delete",
      "deleteHighlightViaPopup"
    );
    if (currentHighlight.hasNote) {
      Fraction.Reporter.gaEvent(
        "V3/highlights",
        "delete",
        "deleteNoteViaHighlightDelete"
      );
    }
    HighlightAction.deleteHighlight(this.props.isbn, currentHighlight.syncId);
    Fraction.Helpers.removeModal();
    Fraction.Reporter.gaEvent("reader/highlights/popup/delete-highlight");
  }

  deleteHighlight(e) {
    const { currentHighlight } = this.props;
    if (currentHighlight && currentHighlight.hasNote) {
      this.props.closePopover();
      Fraction.Helpers.showModal({
        title: i18n.t("reader.notebook.note-associated-title"),
        content: <span>{i18n.t("reader.notebook.note-associated-text")}</span>,
        buttons: [
          {
            label: i18n.t("base.cancel"),
            click: Fraction.Helpers.removeModal,
            defaultClass: "noButton"
          },
          {
            label: i18n.t("base.delete"),
            click: () => {
              this.deleteHighlightOverride(currentHighlight);
            }
          }
        ]
      });
    } else {
      this.deleteHighlightOverride(currentHighlight);
      this.props.closePopover();
    }
  }

  makeHighlight(id) {
    let currentMarker = MarkerStore.get(id);
    if (this.props.currentHighlight.syncId) {
      HighlightAction.updateHighlight(
        this.props.isbn,
        this.props.currentHighlight.syncId,
        {
          markerId: currentMarker.globalId,
          noteText: this.props.currentNoteText
        }
      );
      Fraction.Reporter.gaEvent("reader/highlights/popup/update-highlight");
    } else {
      this.props.addHighlight(this.props.currentNoteText);
      Fraction.Reporter.gaEvent(
        "reader/highlights/popup/add-highlight",
        "via-add-highlight"
      );
      Fraction.Reporter.gaEvent("V3/highlights", "add", "addHighlightViaPopup");
    }
    this.props.closePopover();
  }

  onSlowClick(id) {
    this.makeHighlight(id);
    Fraction.Reporter.gaEvent(
      "V3/highlights",
      "click",
      "changeExistingHighlightColor"
    );
  }

  _markers() {
    const { markers, selected, hovered } = this.state;
    if (markers) {
      return markers.map(marker => {
        if (isEmojiMarker(marker)) {
          return null;
        }
        let selectedStyle;
        if (this.props.updateHighlight && this.props.currentHighlight) {
          selectedStyle =
            marker.globalId === this.props.currentHighlight.markerId;
        } else {
          selectedStyle = selected === marker || hovered === marker;
        }
        let border, margin;
        if (selectedStyle) {
          border = "3px solid " + marker.darkColor;
        } else {
          border = "1px solid " + marker.darkColor;
        }

        let selectedIcon;
        // This is to render the X overlay if there is an existing highlight
        if (
          this.props.currentHighlight &&
          marker.globalId === this.props.currentHighlight.markerId
        ) {
          selectedIcon = (
            <div
              className="selected-icon"
              style={{ background: "rgba(117,117,117,0.70)" }}
            />
          );
        }
        const fastHighlighterOn = this.props.fast
          ? "fasthighlighter"
          : "slowhighlighter";
        return (
          <span
            key={"marker-button-" + marker.darkColor + "-" + marker.globalId}
            className={fastHighlighterOn}
          >
            <button
              style={{
                background: marker.color,
                border,
                margin
              }}
              className={this._markerIconClass(marker)}
              onMouseOver={() => {
                this.setState({ hovered: marker });
              }}
              onMouseOut={() => this.setState({ hovered: false })}
              onClick={e => {
                this._updateHighlight(e, marker);
              }}
            >
              <span className="hint-text">
                {this.props.currentHighlight
                  ? this._isDeletable(marker)
                    ? i18n.t("reader.notebook.delete-highlight", {
                        label: marker.label
                      })
                    : i18n.t("highlighters.change-highlight", {
                        label: marker.label
                      })
                  : i18n.t("highlighters.create-highlight", {
                      label: marker.label
                    })}
              </span>
              {selectedIcon}
              {marker.shared && (
                <Isvg
                  style={{ color: marker.darkColor }}
                  src="../../../img/public_icon.svg"
                />
              )}
            </button>
          </span>
        );
      });
    } else {
      return <VstLoader />;
    }
  }

  render() {
    const { selected, hovered } = this.state;
    const fastHighlighterOn = this.props.fast ? "fasthighlighter" : "";
    return (
      <div id="highlighter-colors" data-testid="highlighter-colors">
        <h4 className="highlight-label">
          {!this.props.fastHighlighting && this.props.fast && !hovered
            ? i18n.t("reader.buttons.select-highlighter")
            : (hovered && hovered.label) || (selected && selected.label)}
        </h4>
        <div className="color-pallete">
          {this._markers()}
          {this.props.fast && this.props.fastHighlighting && (
            <span className={fastHighlighterOn}>
              <button
                id="fast-highlight-off-container"
                className="noButton select-marker"
                onMouseOver={() =>
                  this.setState({
                    hovered: { label: i18n.t("reader.buttons.turn-off") }
                  })
                }
                onMouseOut={() => this.setState({ hovered: false })}
                onClick={() => this.props.onFastClick(false)}
              >
                <span className="hint-text">
                  {i18n.t("reader.buttons.fast-highlighting-turn-off")}
                </span>
                <Isvg src="../../../img/highlight_x.svg" />
              </button>
            </span>
          )}
        </div>
      </div>
    );
  }
}

HighlighterColors.defaultProps = {
  fast: false,
  color: null,
  currentHighlight: null,
  fastHighlighting: false,
  updateHighlight: false,
  addHighlight: () => {},
  resetHighlight: () => {},
  onFastClick: () => {},
  onSlowClick: () => {},
  closePopover: () => {}
};
